// export function buildEditorialLayout(events) {
//   const COLS = 3

//   const grid = [] // virtual occupancy matrix
//   const layout = []

//   function ensureRow(row) {
//     while (grid.length <= row) {
//       grid.push(new Array(COLS).fill(null))
//     }
//   }

//   function canPlace(row, col, w, h) {
//     if (col + w > COLS) return false

//     for (let r = row; r < row + h; r++) {
//       ensureRow(r)

//       for (let c = col; c < col + w; c++) {
//         if (grid[r][c] !== null) return false
//       }
//     }

//     return true
//   }

//   function occupy(row, col, w, h, id) {
//     for (let r = row; r < row + h; r++) {
//       ensureRow(r)

//       for (let c = col; c < col + w; c++) {
//         grid[r][c] = id
//       }
//     }
//   }

//   function findNextCell() {
//     let r = 0

//     while (true) {
//       ensureRow(r)

//       for (let c = 0; c < COLS; c++) {
//         if (grid[r][c] === null) {
//           return [r, c]
//         }
//       }

//       r++
//     }
//   }

//   function findFeaturedSpot() {
//     let r = 0

//     while (true) {
//       ensureRow(r)

//       for (let c = 0; c < COLS; c++) {
//         if (canPlace(r, c, 2, 2)) {
//           return [r, c]
//         }
//       }

//       r++
//     }
//   }

//   for (const event of events) {
//     const isFeatured = event.featured

//     let row, col, rowSpan, colSpan

//     if (isFeatured) {
//       rowSpan = 2
//       colSpan = 2

//       ;[row, col] = findFeaturedSpot()
//       occupy(row, col, 2, 2, event.id)
//     } else {
//       rowSpan = 1
//       colSpan = 1

//       ;[row, col] = findNextCell()
//       occupy(row, col, 1, 1, event.id)
//     }

//     layout.push({
//       id: event.id,
//       event,
//       row,
//       col,
//       rowSpan,
//       colSpan
//     })
//   }

//   return layout
// }

export function buildEditorialLayout(events) {
  const COLS = 3

  const grid = []
  const layout = []

  // 🔁 toggles featured placement direction
  let featuredToggle = false

  function ensureRow(row) {
    while (grid.length <= row) {
      grid.push(new Array(COLS).fill(null))
    }
  }

  function canPlace(row, col, w, h) {
    if (col + w > COLS) return false

    for (let r = row; r < row + h; r++) {
      ensureRow(r)

      for (let c = col; c < col + w; c++) {
        if (grid[r][c] !== null) return false
      }
    }

    return true
  }

  function occupy(row, col, w, h, id) {
    for (let r = row; r < row + h; r++) {
      ensureRow(r)

      for (let c = col; c < col + w; c++) {
        grid[r][c] = id
      }
    }
  }

  function findNextCell() {
    let r = 0

    while (true) {
      ensureRow(r)

      for (let c = 0; c < COLS; c++) {
        if (grid[r][c] === null) {
          return [r, c]
        }
      }

      r++
    }
  }

  // ⭐ UPDATED FEATURED PLACEMENT (alternating sides)
  function findFeaturedSpot() {
    let r = 0

    while (true) {
      ensureRow(r)

      // alternate preferred placement order
      const preferredCols = featuredToggle
        ? [0, 1] // try left first
        : [1, 0] // try right first

      for (const c of preferredCols) {
        if (canPlace(r, c, 2, 2)) {
          featuredToggle = !featuredToggle // flip for next featured
          return [r, c]
        }
      }

      r++
    }
  }

  for (const event of events) {
    let row, col, rowSpan, colSpan

    if (event.tags?.includes('Featured')) {
      rowSpan = 2
      colSpan = 2
      ;[row, col] = findFeaturedSpot()
      occupy(row, col, 2, 2, event.id)
    } else {
      rowSpan = 1
      colSpan = 1
      ;[row, col] = findNextCell()
      occupy(row, col, 1, 1, event.id)
    }

    layout.push({
      id: event.id,
      event,
      row,
      col,
      rowSpan,
      colSpan
    })
  }

  return layout
}
